import { Component, OnInit } from '@angular/core'
import { OrderConfirmationThankYouMessageComponent } from '@spartacus/order/components'
import { GlobalMessageService, TranslationService } from '@spartacus/core'
import { OrderFacade } from '@spartacus/order/root'

@Component({
    selector: 'app-custom-order-confirmation-thank-you-message',
    templateUrl: './custom-order-confirmation-thank-you-message.component.html',
    styleUrls: ['./custom-order-confirmation-thank-you-message.component.scss'],
    standalone: false
})
export class CustomOrderConfirmationThankYouMessageComponent
  extends OrderConfirmationThankYouMessageComponent
  implements OnInit
{
  constructor(
    protected orderFacade: OrderFacade,
    protected globalMessageService: GlobalMessageService,
    protected translationService: TranslationService
  ) {
    super(orderFacade, globalMessageService, translationService)
  }
  ngOnInit() {
    super.ngOnInit()
  }
}
